import { getReferralDataForAuth } from '@/features/save-log'
import { fetchWithToken } from '@/services'
import fetcher from '@/services/fetcher'
import { buildQuery } from '@/utils/helpers'
export * from './otp-service'

const SIGNIN = `
mutation generateCustomerToken($email: String!, $password: String!) {
    generateCustomerToken(email: $email, password: $password) {
      token
    }
  }
`

// GraphQL mutations cho OTP login
const REQUEST_LOGIN_OTP = `
mutation RequestLoginOtp($phone: String!) {
  requestLoginOtp(phone: $phone)
}
`

const VERIFY_OTP_AND_LOGIN = `
mutation verifyOtpAndLogin($phone: String!, $otp: String!, $meta_log: String, $referral_source: String, $target_url: String, $camp: String, $adsid: String, $platform: String, $referral_type: String) {
  verifyOtpAndLogin(
    phone: $phone
    otp: $otp
    meta_log: $meta_log
    referral_source: $referral_source
    target_url: $target_url
    camp: $camp
    adsid: $adsid
    platform: $platform
    referral_type: $referral_type
  ) {
    token
  }
}                    
`

const SET_INITIAL_PASSWORD = `
mutation SetInitialPassword($newPassword: String!) {
  setInitialPassword(newPassword: $newPassword)
}
`

const SIGNUP = `
mutation createCustomer($input: CustomerCreateInput!) {
  createCustomerV2(input: $input) {
    customer {
      __typename
      email
    }
  }
}
`
const GET_SOCIAL_LINKS = `
query getSocialLoginUrl {
  socialLoginUrl {
    key
    label
    login_url
  }
}
`
//missing field '  phone_number'
const GET_INFO = `
query getCustomerInfor{
  customer {
  body_metrics {
            bmi
            gender
            height
            age_range
            weight
        }
    addresses {
      city
      tag
      country_code
      default_billing
      default_shipping
      firstname
      id
      lastname
      middlename
      region_id
      street
      suffix
      telephone
      customer_notes
      vat_id
      custom_attributes {
        value
        attribute_code
      }
    }
    is_phone_registered
    allow_remote_shopping_assistance
    created_at
    date_of_birth
    default_billing
    default_shipping
    email
    firstname
    gender
    is_subscribed
    lastname
    middlename
    phone_number
    profile_picture
    increment_id
    affiliate_information {
      additional_data
      bonus
      cashback
      customer_total_amount
      discount
      image
      level
      parent_bonus
      subtotal_bonus
      title
      total_amount
      total_bonus
      total_wallet_money
      total_click
      total_children
      total_revenue
      total_order
    }
    account_holder
    account_number
    account_bank
  }
}`

const UPDATE_BODY_METRICS = `
mutation updateBodyMetrics(
  $height: Int!
  $weight: Int!
  $gender: Int!
  $age_range: String!
) {
  updateBodyMetrics(
    height: $height
    weight: $weight
    gender: $gender
    age_range: $age_range
  ) {
    age_range
    bmi
    gender
    height
    weight
  }
}`

const REQUEST_RESET_PASSWORD = `
mutation requestPasswordResetEmail($email: String!) {
  requestPasswordResetEmail(email: $email)
}
`
const RESET_PASSWORD = `
mutation resetPassword(
  $email: String!
  $otpToken: String!
  $newPassword: String!
) {
  resetPassword(
    email: $email
    resetPasswordToken: $otpToken
    newPassword: $newPassword
  )
}`

const CHANGE_PASSWORD = `
mutation changeCustomerPassword($currentPassword: String!, $newPassword: String!) {
  changeCustomerPassword(
    currentPassword: $currentPassword
    newPassword: $newPassword
  ) {
    email
  }
}
`

const LOGOUT = `
mutation revokeCustomerToken {
  revokeCustomerToken {
    result
  }
}`

const CUSTOMER_OTP_CONFIRMATION = `
  mutation customerOtpConfirmation(
    $otp_code: String!
    $email: String!
    $type: String!
  ) {
    customerOtpConfirmation(otp_code: $otp_code, email: $email, type: $type)
  }
`

const UPDATE_CUSTOMER_QUERIES = `
  mutation updateCustomerV2($input: CustomerUpdateInput!) {
    updateCustomerV2(input: $input) {
      customer {
        email
        firstname
        lastname
      }
    }
  }
`
//profile_upload_picture

export const UPDATE_CUSTOMER = `
  mutation updateCustomerV2($input: CustomerUpdateInput!) {
    updateCustomerV2(input: $input) {
      customer {
        allow_remote_shopping_assistance
        created_at
        date_of_birth
        default_billing
        default_shipping
        email
        profile_picture
        firstname
        gender
        is_subscribed
        lastname
        middlename
        account_holder
        account_number
        account_bank
      }
    }
  }
`

export const LOGIN_SOCIAL_GOOGLE = `
  mutation generateCustomerTokenSocialLogin($state: String!, $code: String!, $scope: String!, $authuser: String!, $prompt: String!, $handle: String!, $new_parent_referral_code: String, $meta_log: String, $referral_source: String, $target_url: String, $camp: String, $adsid: String, $platform: String, $referral_type: String) {
  generateCustomerTokenSocialLogin(
    state: $state
    code: $code
    scope: $scope
    authuser: $authuser
    prompt: $prompt
    handle: $handle
    new_parent_referral_code: $new_parent_referral_code
    meta_log: $meta_log
    referral_source: $referral_source
    target_url: $target_url
    camp: $camp
    adsid: $adsid
    platform: $platform
    referral_type: $referral_type
  ) {
    status
    token
  }
}
`
const registerActionService = async (values: any) => {
  // const registerActionService = async (values: yup.InferType<typeof registerSchema>) => {
  try {
    const response = await fetchWithToken(
      {
        query: SIGNUP,
        variables: {
          input: {
            firstname: values?.firstname,
            email: values?.email,
            lastname: values?.lastname,
            password: values?.password,
            mobile_number: values?.mobile_phone,
            country_code: 'VN',
          },
        },
      },
      {
        next: { revalidate: 1, tags: ['signup'] },
      }
    ).then((res) => res?.payload)

    const isSuccess = response?.data?.createCustomerV2?.customer
    if (!isSuccess) return { status: 'error', message: response?.errors?.[0]?.message }
    return { status: 'success', message: 'Register successfully' }
  } catch (error) {
    console.log(error)
    return { status: 'error', message: "something's wrong", data: JSON.stringify(error) }
  }
}

const getInfoCustomer = async () => {
  try {
    const infoUser = await fetchWithToken(
      {
        query: GET_INFO,
      },
      {
        next: { revalidate: 60, tags: ['customer-info'] },
        cache: 'force-cache',
      }
    )
    const data = infoUser?.payload?.data?.customer
    if (!data) return null
    return data
  } catch (err) {
    console.log(err)
    throw new Error(JSON.stringify(err))
  }
}

const updateInfoCustomer = async (values: Record<string, string>) => {
  const response = await fetchWithToken({
    query: UPDATE_CUSTOMER,
    variables: {
      input: {
        phone_number: values?.phone_number,
        firstname: values?.firstname,
        lastname: values?.lastname,
        profile_upload_picture: values?.profile_upload_picture,
        date_of_birth: values?.date_of_birth,
        account_holder: values?.account_holder,
        account_number: values?.account_number,
        account_bank: values?.account_bank,
      },
    },
  })
  const data = response?.payload?.data?.updateCustomerV2?.customer
  if (!data) return { status: 'error', message: response?.payload?.errors?.[0]?.message, data: null }
  return { status: 'success', message: 'success', data: data }
}
const getSocialLoginUrl = async () => {
  try {
    const response = await fetcher
      .get(buildQuery(GET_SOCIAL_LINKS), {
        next: { revalidate: 60, tags: ['social-login-url'] },
      })
      .then((res) => {
        return res?.payload?.data?.socialLoginUrl as any[]
      })
    return response
  } catch (error) {
    return []
  }
}

// Services cho OTP login
const requestLoginOtp = async (phone: string) => {
  try {
    const response = await fetchWithToken({
      query: REQUEST_LOGIN_OTP,
      variables: { phone },
    })

    const data = response?.payload?.data?.requestLoginOtp

    if (response?.payload?.errors) {
      return { status: 'error', message: response.payload.errors[0]?.message }
    }

    return {
      status: 'success',
      data,
    }
  } catch (error: any) {
    console.error('Error requesting OTP:', error)

    return {
      status: 'error',
      message: error.message,
    }
  }
}

const verifyOtpAndLogin = async (phone: string, otp: string) => {
  try {
    // Lấy referral tracking data từ localStorage (nếu có)
    const referralData = getReferralDataForAuth()
    console.log('phone, otp, referralData', phone, otp)

    let variables: any = {
      phone,
      otp,
    }

    // Thêm referral data nếu có
    if (referralData) {
      Object.assign(variables, {
        meta_log: JSON.stringify(referralData),
        referral_source: referralData.referral_source ?? undefined,
        referral_type: referralData.referral_type ?? undefined,
        target_url: referralData.target_url ?? undefined,
        camp: referralData.camp ?? undefined,
        adsid: referralData.adsid ?? undefined,
        platform: referralData.platform ?? undefined,
        mailing_id: referralData.mailing_id ?? undefined,
      })
    }
    const response = await fetchWithToken({
      query: VERIFY_OTP_AND_LOGIN,
      variables: variables,
    })

    const data = response?.payload?.data?.verifyOtpAndLogin

    if (response?.payload?.errors) {
      return { status: 'error', message: response.payload.errors[0]?.message }
    }

    return {
      status: 'success',
      data,
    }
  } catch (error: any) {
    console.error('Error verifying OTP:', error)

    return {
      status: 'error',
      message: error.message,
    }
  }
}

// Services cho reset password
const requestPasswordResetEmail = async (email: string) => {
  try {
    const response = await fetcher.post('', {
      query: REQUEST_RESET_PASSWORD,
      variables: { email },
    })
    if (response?.payload?.errors) {
      return {
        status: 'error',
        message: response.payload.errors[0]?.message,
      }
    }

    return {
      status: 'success',
      data: response?.payload?.data?.requestPasswordResetEmail,
    }
  } catch (error: any) {
    console.error('Error requesting password reset:', error)

    return {
      status: 'error',
      message: error.message,
    }
  }
}

const confirmOtpForPasswordReset = async (otpCode: string, email: string) => {
  try {
    const response = await fetcher.post('', {
      query: CUSTOMER_OTP_CONFIRMATION,
      variables: {
        otp_code: otpCode,
        email,
        type: 'resetpassword',
      },
    })

    if (response?.payload?.errors) {
      return {
        status: 'error',
        message: response.payload.errors[0]?.message,
      }
    }

    return {
      status: 'success',
      data: response?.payload?.data?.customerOtpConfirmation,
    }
  } catch (error: any) {
    console.error('Error confirming OTP:', error)

    return {
      status: 'error',
      message: error.message,
    }
  }
}

const resetPasswordService = async (email: string, otpToken: string, newPassword: string) => {
  try {
    const response = await fetcher.get(
      buildQuery(RESET_PASSWORD, {
        email,
        resetPasswordToken: otpToken,
        newPassword,
      })
    )

    if (response?.payload?.errors) {
      return {
        status: 'error',
        message: response.payload.errors[0]?.message,
      }
    }

    return {
      status: 'success',
      data: response?.payload?.data?.resetPassword,
    }
  } catch (error: any) {
    console.error('Error resetting password:', error)
    return {
      status: 'error',
      message: error.message,
    }
  }
}

// Service cho cập nhật mật khẩu lần đầu
const setInitialPasswordService = async (newPassword: string) => {
  try {
    const response = await fetchWithToken({
      query: SET_INITIAL_PASSWORD,
      variables: { newPassword },
    })

    if (response?.payload?.errors) {
      return {
        status: 'error',
        message: response.payload.errors[0]?.message || 'Có lỗi xảy ra khi cập nhật mật khẩu',
      }
    }

    return {
      status: 'success',
      data: response?.payload?.data?.setInitialPassword,
      message: 'Cập nhật mật khẩu thành công',
    }
  } catch (error: any) {
    console.error('Error setting initial password:', error)
    return {
      status: 'error',
      message: error.message || 'Có lỗi xảy ra khi cập nhật mật khẩu',
    }
  }
}

const updateBodyMetrics = async ({
  height,
  weight,
  gender = 1,
  age_range = 'unset',
}: {
  height: number
  weight: number
  gender?: number
  age_range?: string
}) => {
  try {
    if (!height || !weight) {
      return { status: 'error', message: 'Height and Weight are required', data: null }
    }

    const response = await fetchWithToken(
      {
        query: UPDATE_BODY_METRICS,
        variables: { height, weight, gender, age_range },
      },
      {
        next: {
          revalidate: 120,
          tags: ['update-body-metrics', `${weight}-${height}-${gender}-${age_range}`],
        },
      }
    )

    const data = response?.payload?.data?.cartPriceRule
    if (response?.payload?.errors) {
      return { status: 'error', message: response.payload.errors[0]?.message, data: null }
    }

    return { status: 'success', data, message: '' }
  } catch (error) {
    console.error('Error updating body metrics:', error)
    return { status: 'error', message: 'Có lỗi xảy ra khi cập nhật thông tin cơ thể', data: null }
  }
}

export {
  CHANGE_PASSWORD,
  confirmOtpForPasswordReset,
  CUSTOMER_OTP_CONFIRMATION,
  GET_INFO,
  getInfoCustomer,
  getSocialLoginUrl,
  LOGOUT,
  registerActionService,
  REQUEST_RESET_PASSWORD,
  requestLoginOtp,
  requestPasswordResetEmail,
  RESET_PASSWORD,
  resetPasswordService,
  setInitialPasswordService,
  SIGNIN,
  SIGNUP,
  updateBodyMetrics,
  updateInfoCustomer,
  verifyOtpAndLogin,
}
